import script from "./sp_item.vue?vue&type=script&setup=true&lang=js"
export * from "./sp_item.vue?vue&type=script&setup=true&lang=js"

import "./sp_item.vue?vue&type=style&index=0&id=39f36c51&scoped=true&lang=scss"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39f36c51"]])

export default __exports__